import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from './app-config.service';
import { AuthService } from './auth.service';
import { BaseService } from './base-service.service';
import {
  CreatePaymentTransactionBatchRequest,
  IntellioHttpResponse,
} from '@intellio/shared/models';

@Injectable({
  providedIn: 'root',
})
export class AppPaymentsService extends BaseService {
  constructor(
    protected client: HttpClient,
    protected configService: AppConfigService,
    protected authService: AuthService
  ) {
    super(client, configService, authService);
  }

  getPayments(applicationId) {
    const getPaymentsUrl = `/api/applications/${applicationId}/payments`;
    return this.get<any[]>(getPaymentsUrl);
  }

  getMostRecentPayment(applicationId) {
    const getPaymentUrl = `/api/applications/${applicationId}/payment/recent`;
    return this.get<any>(getPaymentUrl);
  }

  getTotalCost(applicationId) {
    const getTotalCostUrl = `/api/applications/${applicationId}/paymentCost`;
    return this.get<any>(getTotalCostUrl);
  }

  getTotalCostByRegulation(applicationId, regulationId) {
    const getTotalCostByRegulationUrl = `/api/applications/${applicationId}/regulations/${regulationId}/paymentsTotal`;
    return this.get<any>(getTotalCostByRegulationUrl);
  }

  getPricing(id, capacity) {
    const getPricingUrl = `/api/applications/${id}/pricing?nameplateCapacity=${capacity}`;
    return this.get<any>(getPricingUrl);
  }

  getPaymentTypes() {
    const getPaymentTypesUrl = '/api/payments/type';
    return this.get<any>(getPaymentTypesUrl);
  }

  getPaymentTypesByAppTypeJurisdiction(applicationId) {
    const getPaymentTypesByAppTypeJurisdictionUrl = `/api/payments/${applicationId}/type`;
    return this.get<any>(getPaymentTypesByAppTypeJurisdictionUrl);
  }

  getPaymentStatuses() {
    const getPaymentStatusesUrl = '/api/payments/transactionStatus';
    return this.get<any>(getPaymentStatusesUrl);
  }

  createPaymentTransaction(payment) {
    const createPaymentTransactionUrl = '/api/payments';
    return this.post(createPaymentTransactionUrl, payment);
  }

  createPaymentTransactionsBatch(
    applicationId: string,
    payments: CreatePaymentTransactionBatchRequest[]
  ) {
    const createPaymentTransactionsBatchUrl = `/api/applications/${applicationId}/payments/batch`;
    return this.post<string[]>(createPaymentTransactionsBatchUrl, payments);
  }

  getPaymentTransaction(paymentId) {
    const getPaymentTransactionUrl = `/api/payments/${paymentId}`;
    return this.get<any>(getPaymentTransactionUrl);
  }

  updatePaymentTransaction(payment) {
    const updatePaymentTransactionUrl = `/api/payments/${payment.id}`;
    return this.put(updatePaymentTransactionUrl, payment);
  }

  generatePaymentLink(paymentId: string) {
    const getPaymentLinkUrl = `/api/payments/${paymentId}/oneTimePayment`;
    return this.get<any>(getPaymentLinkUrl);
  }

  splitProgressBillingPayment(applicationId: string, paymentId: string) {
    const splitProgressBillingPaymentUrl = `/api/applications/${applicationId}/payments/${paymentId}/split`;
    return this.post<any>(splitProgressBillingPaymentUrl);
  }

  createInitialApplicationPayment(id, payment) {
    const createEPaymentFlagUrl = `/api/applications/${id}/submit/payment`;
    return this.post(createEPaymentFlagUrl, payment);
  }
}
